'use client';

import { FadeIn } from '../../animation/FadeIn.jsx';
import { cn } from '../../../lib/utils.js';

/**
 * 2-Spalten-Vergleich. column: { name, price?, priceNote?, yearly?, highlighted?,
 * features: [{ text, included }] }.
 */
export function ComparisonBlock({ background, eyebrow, headline, columns = [] }) {
  return (
    <section className={cn('py-20 md:py-32', background)}>
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        {(eyebrow || headline) && (
          <FadeIn>
            <div className="max-w-2xl mx-auto text-center mb-12 md:mb-16">
              {eyebrow && (
                <p className="text-accent-dark dark:text-accent font-semibold uppercase tracking-wider text-sm mb-2">
                  {eyebrow}
                </p>
              )}
              {headline && (
                <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-gray-900 dark:text-gray-100">
                  {headline}
                </h2>
              )}
            </div>
          </FadeIn>
        )}
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          {columns.map((column, i) => (
            <FadeIn key={i} delay={i * 0.15}>
              <div
                className={cn(
                  'rounded-lg p-8 h-full',
                  column.highlighted
                    ? 'bg-accent/10 dark:bg-accent/20 border-2 border-accent ring-2 ring-accent/20'
                    : 'bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700'
                )}
              >
                {column.highlighted && (
                  <div className="text-accent-dark dark:text-accent font-semibold text-sm uppercase tracking-wider mb-4">
                    Empfohlen
                  </div>
                )}
                <div className="font-heading font-bold text-xl mb-2 text-gray-900 dark:text-gray-100">
                  {column.name}
                </div>
                {column.price && (
                  <div className="font-heading font-bold text-4xl text-gray-900 dark:text-gray-100 mb-1">
                    {column.price}
                  </div>
                )}
                {column.priceNote && (
                  <div className="text-sm text-gray-500 dark:text-gray-400 mb-2">{column.priceNote}</div>
                )}
                {column.yearly && (
                  <div className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-6 pb-6 border-b border-gray-200 dark:border-gray-700">
                    = {column.yearly}
                  </div>
                )}
                <ul className="space-y-3">
                  {(column.features ?? []).map((feature, j) => (
                    <li key={j} className="flex items-center gap-3 text-sm">
                      <span className={feature.included ? 'text-green-500' : 'text-red-500'}>
                        {feature.included ? '✓' : '✗'}
                      </span>
                      <span className="text-gray-700 dark:text-gray-300">{feature.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
